<div class="flag-legend" *ngIf="legendItems?.length">
  <div class="legend-item" *ngFor="let item of legendItems">
    <emerald-icon
      [icon]="item.color === 'red' ? 'flag' : 'check'"
      [color]="item.color"
      [type]="'outlined'"
    ></emerald-icon>
    <span>{{ item.label }}</span>
  </div>
</div>
